import { browser } from '$app/environment';
import { cfgBrand, cfgReownProjectId, cfgStage, Stage } from '@infinitro/config';
import { Api, closeThisModal, loggedIn, ModalDialog, pushModal } from '@infinitro/global';
import { get, writable } from 'svelte/store';
import { AddConnectedAddress, AsyncGetConnectedAddresses } from '../api/api';
const debug = cfgStage() != Stage.Prod;
function log(msg, data) {
    if (debug)
        console.log(msg, data);
}
let wallet_address = undefined;
export const stateConnectedWalletAddress = writable('');
export const stateHasConnectedWallet = writable(false);
export const stateConnectedWalletSigned = writable(false);
export const stateConnectedWalletAddresses = writable([]);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let walletProvider = undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let walletSigner = undefined;
const projectId = cfgReownProjectId() ?? '441421829a4cc3f2eaf2cccd9a34afff';
const brand = cfgBrand();
let appKit = undefined;
let _SiweMessage = undefined;
async function get_SiweMessage() {
    if (_SiweMessage)
        return _SiweMessage;
    const { SiweMessage } = await import('siwe');
    _SiweMessage = SiweMessage;
    return _SiweMessage;
}
let _ethers = undefined;
let _getAddress = undefined;
async function get_ethers() {
    if (_ethers)
        return _ethers;
    const { ethers, getAddress } = await import('ethers');
    _ethers = ethers;
    _getAddress = getAddress;
    return _ethers;
}
let _bsc = undefined;
let _mainnet = undefined;
let _polygon = undefined;
export const get_reown_appkit_networks = async () => {
    if (_bsc && _mainnet && _polygon)
        return [_bsc, _mainnet, _polygon];
    const { bsc, mainnet, polygon } = await import('@reown/appkit/networks');
    _bsc = bsc;
    _mainnet = mainnet;
    _polygon = polygon;
    return [_bsc, _mainnet, _polygon];
};
let _EthersAdapter = undefined;
async function get_EthersAdapter() {
    if (_EthersAdapter)
        return _EthersAdapter;
    const { EthersAdapter } = await import('@reown/appkit-adapter-ethers');
    _EthersAdapter = EthersAdapter;
    return _EthersAdapter;
}
let _initializedLibraries = false;
export const initLibraries = async () => {
    if (_initializedLibraries)
        return;
    try {
        pushModal(ModalDialog.Loading);
        await get_createAppKit();
        await get_reown_appkit_networks();
        await get_EthersAdapter();
        await get_ethers();
        await get_SiweMessage();
        _initializedLibraries = true;
    }
    catch (e) {
        console.warn('error initializing libraries', e);
    }
    closeThisModal(ModalDialog.Loading);
};
let _createAppKit = undefined;
async function get_createAppKit() {
    if (_createAppKit)
        return _createAppKit;
    const { createAppKit } = await import('@reown/appkit');
    _createAppKit = createAppKit;
    return _createAppKit;
}
export const refreshWallets = async () => {
    if (!get(loggedIn))
        return;
    const result = await AsyncGetConnectedAddresses({
        variables: {},
        context: { api: Api.player },
        fetchPolicy: 'network-only'
    });
    console.log(result);
    stateConnectedWalletAddresses.set(result?.data?.getConnectedAddresseses ?? []);
};
export const addConnectedWalletIfNotExists = async (address) => {
    if (get(stateConnectedWalletAddresses).find((wallet) => wallet.addressStr === address))
        return;
    await addConnectedWallet(address);
};
export const addConnectedWallet = async (address) => {
    if (!get(loggedIn))
        return;
    const result = await AddConnectedAddress({
        variables: {
            addressStr: address
        },
        context: { api: Api.player }
    });
    console.log(result);
    await refreshWallets();
};
export const get_appkit = () => {
    if (!browser)
        return undefined;
    if (!appKit) {
        const metadata = {
            name: brand,
            description: `${brand} - Crypto Gaming Platform`,
            url: window.location.origin,
            icons: [`${window.location.origin}/favicon.ico`]
        };
        console.log(`reown project id ${projectId}`);
        appKit = _createAppKit({
            adapters: [new _EthersAdapter()],
            allowUnsupportedChain: true,
            allWallets: 'SHOW',
            debug,
            enableMobileFullScreen: true,
            enableReconnect: true,
            enableWalletGuide: false,
            networks: [_mainnet, _polygon, _bsc],
            features: {
                analytics: true,
                email: false,
                emailShowWallets: true,
                onramp: true,
                socials: [],
                swaps: true
            },
            metadata,
            projectId,
            themeMode: 'dark',
            themeVariables: {
                '--w3m-accent': '#3b82f6'
            }
        });
        appKit.subscribeAccount(async (account) => {
            try {
                log(`subscribeAccount`, account);
                stateHasConnectedWallet.set(account.isConnected);
                if (account.isConnected === false) {
                    wallet_address = undefined;
                    stateConnectedWalletAddress.set('');
                    stateConnectedWalletSigned.set(false);
                    walletProvider = undefined;
                    walletSigner = undefined;
                }
                // warning, this assumes only ethereum addresses can be connected!?
                const address = _getAddress(account.address); // ethers address normalization to checksum
                if (account.address &&
                    address &&
                    account.isConnected === true &&
                    wallet_address !== address) {
                    wallet_address = address;
                    stateConnectedWalletAddress.set(address);
                    if (get(loggedIn)) {
                        await addConnectedWalletIfNotExists(address);
                    }
                }
            }
            catch (e) {
                console.warn(`error subscribing to account ${JSON.stringify(e)}`);
            }
        });
    }
    return appKit;
};
export const checkConnectedWallet = async () => {
    const wc = get_appkit();
    if (!wc) {
        console.log(`wallet connect instance not found`);
        return false;
    }
    const account = wc.getAccount();
    log('checkConnectedWallet', account);
    return account?.isConnected ?? false;
};
export async function sign(address, statement, nonce) {
    await initLibraries();
    try {
        if (!address || !statement) {
            return [false, undefined, `address, statement and nonce are required`];
        }
        const wc = get_appkit();
        if (!wc) {
            return [false, undefined, `wallet connect instance not found`];
        }
        const provider = wc.getWalletProvider();
        if (provider) {
            walletProvider = new _ethers.BrowserProvider(provider);
            walletSigner = await walletProvider.getSigner();
        }
        else {
            return [false, undefined, `provider not found`];
        }
        return await confirmSignature(address, statement, nonce);
    }
    catch (e) {
        return [false, undefined, `error signing message: ${JSON.stringify(e)}`];
    }
}
const confirmSignature = async (address, statement, nonce) => {
    await initLibraries();
    if (!browser || !address || !statement)
        return [false, undefined, `address, statement and nonce are required`];
    try {
        const message = {
            domain: window.location.host,
            address,
            statement,
            uri: window.location.origin,
            version: '1',
            chainId: 1,
            nonce
        };
        const siweMessage = new _SiweMessage(message);
        const preparedMessage = siweMessage.prepareMessage();
        const signature = await walletSigner.signMessage(preparedMessage);
        const fields = await siweMessage.verify({ signature });
        if (fields?.success) {
            const signedMessage = {
                addressStr: address,
                message: fields?.data,
                preparedMessage,
                signature
            };
            stateConnectedWalletSigned.set(true);
            return [true, signedMessage, undefined];
        }
        return [false, undefined, `signature verification failed`];
    }
    catch (e) {
        if (e?.error?.message) {
            return [false, undefined, e?.error?.message];
        }
        return [false, undefined, `error signing or verifying message: ${JSON.stringify(e)}`];
    }
};
export const connect = async (event) => {
    if (!browser)
        return;
    if (event)
        event.preventDefault();
    try {
        await initLibraries();
        const wc = get_appkit();
        if (!wc) {
            console.log(`wallet connect instance not found`);
            return;
        }
        setTimeout(async () => {
            try {
                closeThisModal(ModalDialog.Loading);
                log(`opening wc...`);
                const account = wc.getAccount();
                if (account && account.isConnected)
                    return;
                await wc.open();
            }
            catch (e) {
                closeThisModal(ModalDialog.Loading);
                console.warn('error opening wallet connect', e);
            }
        }, 300);
    }
    catch (e) {
        console.warn('error connecting to wallet', e);
    }
};
export const open = async (event) => {
    if (!browser)
        return;
    if (event)
        event.preventDefault();
    try {
        await initLibraries();
        const wc = get_appkit();
        if (!wc) {
            console.log(`wallet connect instance not found`);
            return;
        }
        setTimeout(async () => {
            try {
                closeThisModal(ModalDialog.Loading);
                log(`opening wc...`);
                await wc.open();
            }
            catch (e) {
                closeThisModal(ModalDialog.Loading);
                console.warn('error opening wallet connect', e);
            }
        }, 300);
    }
    catch (e) {
        console.warn('error connecting to wallet', e);
    }
};
export const close = async () => {
    if (!browser)
        return;
    try {
        const wc = get_appkit();
        if (!wc) {
            console.log(`wallet connect instance not found`);
            return;
        }
        if (wc)
            return wc.close();
        return;
    }
    catch (e) {
        console.warn('error closing wallet connect', e);
    }
};
export const disconnect = async () => {
    if (!browser)
        return;
    try {
        const wc = get_appkit();
        if (!wc) {
            console.log(`wallet connect instance not found`);
            return;
        }
        await wc.disconnect();
    }
    catch (e) {
        console.warn('error disconnecting from wallet', e);
    }
};
export const disconnectIfInitialized = async () => {
    if (!browser)
        return;
    try {
        // will disconnect only of libraries are already initialized
        if (!_initializedLibraries)
            return;
        const wc = get_appkit();
        if (!wc) {
            console.log(`wallet connect instance not found`);
            return;
        }
        await wc.disconnect();
    }
    catch (e) {
        console.warn('error disconnecting from wallet', e);
    }
};
